import * as React from "react";
import { Select } from "antd";
import { ForwardSelect } from "./ForwardSelect";
import { loadPresets } from "../lib/loadPresets";
import { Load } from "../lib/model/Load";

type Props = {
  value: Load;
  onSelect: (value: Load) => void;
};

const Option = Select.Option;

export class LoadSelect extends React.Component<Props> {
  render() {
    const { value } = this.props;
    return (
      <ForwardSelect
        label="* Ladungsträger"
        onSelect={this.handleSelect}
        value={value.label}
      >
        {loadPresets.map((p, i) => (
          <Option key={`${i}`} value={i}>
            {p.label}
          </Option>
        ))}
      </ForwardSelect>
    );
  }
  handleSelect = (index: number, option: React.ReactElement<any>) => {
    const selected = loadPresets[index];
    this.props.onSelect(selected);
  };
}
